
import { mixins, Options, Prop } from 'vue-property-decorator'

import ContentCardMixin from '../../mixins/ContentCardMixin'
import GalleryFull from '../icons/GalleryFull.vue'
import Play from '../icons/Play.vue'
import NavLink from '../NavLink.vue'
import Tag from '../Tag.vue'
import ContentImage from './ContentImage.vue'

@Options({
  name: 'ContentCardLeftImg',
  components: {
    ContentImage,
    NavLink,
    Play,
    Tag,
    GalleryFull
  }
})
export default class ContentCardLeftImg extends mixins(ContentCardMixin) {
  @Prop({
    type: Boolean,
    default: false
  })
  readonly isLcp!: boolean
}
